/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ companyType: NonNullable<unknown> }} Client_Company_Type_LabelInputs */

const en_client_company_type_label = /** @type {(inputs: Client_Company_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.companyType === "carrier") return /** @type {LocalizedString} */ (`Carrier`);
	if (i?.companyType === "transport") return /** @type {LocalizedString} */ (`Transport`);
	if (i?.companyType === "rental_agency") return /** @type {LocalizedString} */ (`Rental agency`);
	if (i?.companyType === "insurance") return /** @type {LocalizedString} */ (`Insurance`);
	if (i?.companyType === "company") return /** @type {LocalizedString} */ (`Company`);
	if (i?.companyType === "association") return /** @type {LocalizedString} */ (`Association`);
	if (i?.companyType === "cooperative") return /** @type {LocalizedString} */ (`Cooperative`);
	if (i?.companyType === "union") return /** @type {LocalizedString} */ (`Union`);
	if (i?.companyType === "app_platform") return /** @type {LocalizedString} */ (`App platform`);
	if (i?.companyType === "logistics") return /** @type {LocalizedString} */ (`Logistics`);
	if (i?.companyType === "other") return /** @type {LocalizedString} */ (`Other`);
	return /** @type {LocalizedString} */ (`${i?.companyType}`)
	
};

const pt_br2_client_company_type_label = /** @type {(inputs: Client_Company_Type_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.companyType === "carrier") return /** @type {LocalizedString} */ (`Transportadora`);
	if (i?.companyType === "transport") return /** @type {LocalizedString} */ (`Viação`);
	if (i?.companyType === "rental_agency") return /** @type {LocalizedString} */ (`Locadora`);
	if (i?.companyType === "insurance") return /** @type {LocalizedString} */ (`Seguradora`);
	if (i?.companyType === "company") return /** @type {LocalizedString} */ (`Empresa`);
	if (i?.companyType === "association") return /** @type {LocalizedString} */ (`Associação`);
	if (i?.companyType === "cooperative") return /** @type {LocalizedString} */ (`Cooperativa`);
	if (i?.companyType === "union") return /** @type {LocalizedString} */ (`Sindicato`);
	if (i?.companyType === "app_platform") return /** @type {LocalizedString} */ (`Plataforma de App`);
	if (i?.companyType === "logistics") return /** @type {LocalizedString} */ (`Logística`);
	if (i?.companyType === "other") return /** @type {LocalizedString} */ (`Outro`);
	return /** @type {LocalizedString} */ (`${i?.companyType}`)
	
};

/**
* | companyType | output |
* | --- | --- |
* | "carrier" | "Carrier" |
* | "transport" | "Transport" |
* | "rental_agency" | "Rental agency" |
* | "insurance" | "Insurance" |
* | "company" | "Company" |
* | "association" | "Association" |
* | "cooperative" | "Cooperative" |
* | "union" | "Union" |
* | "app_platform" | "App platform" |
* | "logistics" | "Logistics" |
* | "other" | "Other" |
* | * | "{companyType}" |
*
* @param {Client_Company_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const client_company_type_label = /** @type {((inputs: Client_Company_Type_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Company_Type_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_company_type_label(inputs)
	return pt_br2_client_company_type_label(inputs)
});